// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__cIx9y","approved":"Status_approved__3M6zu","rejected":"Status_rejected__3tLrQ","expired":"Status_expired__1Nvwc","label":"Status_label__3cSPD"};